(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/examine-wager/assets/javascripts/examine.js') >= 0) return;  svs.modules.push('/components/payment/examine-wager/assets/javascripts/examine.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const examine = async (data, cb) => {
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)) {
    cb && cb({
      message: 'Customer service login, not calling api.'
    });
  } else if (!data || !data.examinedSerial || !data.productId) {
    cb && cb({
      message: 'Missing or invalid wager data'
    });
  } else {
    try {
      const modifiedData = _objectSpread(_objectSpread({}, data), {}, {
        drawNum: parseInt(data.drawNum, 10)
      });
      const customerBetExaminedPromise = svs.core.jupiter.callAsync({
        method: 'POST',
        path: '/customerbet/1/wager/examined',
        data: [modifiedData.examinedSerial]
      });
      const wagerExaminedPromise = svs.core.jupiter.callAsync({
        method: 'POST',
        path: '/wager/2/examined',
        data: modifiedData
      });
      const [customerBetExaminedResponse, wagerExaminedResponse] = await Promise.all([customerBetExaminedPromise, wagerExaminedPromise]);
      cb && cb(null, {
        customerBetExaminedResponse,
        wagerExaminedResponse
      });
    } catch (err) {
      cb && cb(err, null);
    }
  }
};
setGlobal('svs.components.payment.examineWager.examine', examine);

 })(window);